import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { useParams, useHistory } from 'react-router';
import PropTypes from 'prop-types';
import { Card, Button } from '@mui/material';

import * as actions from '../../redux/actions';
import { BackButton } from '../../components/Button';
import { UserForm } from '../../components/Forms';
import { Loading } from '../../components/Loading';
import { Error } from '../../components/Error';
import { ViewTitle } from '../../components/ViewTitle';

export default function CreateUserFromEmployee({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const employee = useSelector((state) => state.employee);

  const history = useHistory();
  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm({
    defaultValues: {},
  });

  useEffect(() => {
    dispatch(actions.employeeGet(id));

    return () => {};
  }, []);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const onSubmit = async (data) => {
    try {
      await dispatch(actions.employeePut(id, { createUser: true, ...data }));
      await dispatch(actions.employeeGet(id));
      history.goBack();
      alert('สำเร็จ');
    } catch (error) {
      alert(`สร้างผู้ใช้งานไม่สำเร็จ ${error?.message}`);
      console.log(error);
    }
  };

  if (employee.isLoading || employee.rows) {
    return <Loading />;
  }
  if (!employee.isLoading && employee.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
        </div>
        <div>
          <Card className="p-6">
            <form onSubmit={handleSubmit(onSubmit)}>
              <UserForm
                Controller={Controller}
                control={control}
                errors={errors}
              />
              <div className="flex flex-row justify-end gap-1 py-4">
                <Button variant="contained" type="submit">
                  บันทึก
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}
CreateUserFromEmployee.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

CreateUserFromEmployee.defaultProps = {
  title: '',
  subtitle: '',
};
